export const fileIdToUrl = (fileId: string, downloadAttachment = true) =>
  `/data/s3-uploads/${fileId}?download=${downloadAttachment.toString()}`;
